const state = {
  waitingForConnection: false,
  online: false,
  checkCodeDone: false,
  isLoading: false,
};

const mutations = {
  SET_LOADING: (state) => {
    state.isLoading = true;
  },
  UNSET_LOADING: (state) => {
    state.isLoading = false;
  },
  SET_ONLINE: (state) => {
    state.online = true;
  },
  SET_OFFLINE: (state) => {
    state.online = false;
  },
  SET_WAITING_FOR_CONNECTION: (state) => {
    state.waitingForConnection = true;
  },
  UNSET_WAITING_FOR_CONNECTION: (state) => {
    state.waitingForConnection = false;
  },
  UPDATE_CHECKCODEDONE: (state, payload) => {
    state.checkCodeDone = payload;
  },
};

const getters = {
  isLoading: (state) => state.isLoading,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
